/**
 * Signals, not values: the mount rebuilds its inputs when the template record changes, and the board
 * must see the new scope without being re-created.
 */
import { ActivityEntityName, JobTemplate } from '@jms/model';
import type { EntityBoardContext } from '@workbuddy/ui/v2/blocks/entity.board';

/** One const because two things must agree: the board's `recordScopes` and the walker into a row. */
export const JOB_TEMPLATE_QUESTION_SCOPE = 'template.questions';

/** Board rows cache key. Every write invalidates it, so the commands must not spell it apart. */
export const JOB_TEMPLATE_QUESTION_QUERY_KEY = [ActivityEntityName.JobTemplateQuestions, 'items'];

export interface JobTemplateQuestionBoardParams {
  /**
   * The whole record, not a summary: Add is addressed by its id, the visibility rule offers its sibling
   * questions, and Preview runs the template — none of which a single row can serve.
   */
  readonly template: () => JobTemplate | null;
  /** False while the record is readonly or the user lacks Manage — Add / Edit / Delete stay hidden. */
  readonly writable: () => boolean;
  /** Host refresh after any mutation; the template record carries the questions it just changed. */
  readonly questionsChanged: () => void;
  /**
   * On the bag because the dialog session hands a custom component only `params` and create-time
   * `initialValues` — never the route's record id. Absent on Add.
   */
  readonly questionId?: string;
}

export type JobTemplateQuestionBoardContext = EntityBoardContext & {
  readonly params: JobTemplateQuestionBoardParams;
};
